import { useSearchParams } from 'react-router-dom';

import routes from '../../common/constants/routes';

const PREVIEW_PARAM = 'preview';
const PREVIEW_TOKEN_PATTERN = /^[a-f0-9]{8,32}$/;

/**
 * Token náhledu nezveřejněného partnera z URL (`?preview=<token>`, odkaz z back-office).
 * BE s ním vrátí i vypnutého partnera; FE ho musí přenášet do odkazů uvnitř katalogu,
 * aby náhled nezmizel po kliknutí do detailu.
 */
export const usePreviewToken = (): string | null => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get(PREVIEW_PARAM);
  return token && PREVIEW_TOKEN_PATTERN.test(token) ? token : null;
};

/** Cesta do detailu partnera s přeneseným náhledem a volitelnou předvybranou službou. */
export const partnerDetailPath = (partnerSlug: string, preview: string | null, offerSlug?: string): string => {
  const params = new URLSearchParams();
  if (offerSlug) params.set('offer', offerSlug);
  if (preview) params.set(PREVIEW_PARAM, preview);
  const query = params.toString();
  return `${routes.otherServices}${partnerSlug}${query ? `?${query}` : ''}`;
};

/** Cesta na přehled katalogu s přeneseným náhledem. */
export const catalogPath = (preview: string | null): string =>
  preview ? `${routes.otherServices}?${PREVIEW_PARAM}=${preview}` : routes.otherServices;
